import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-project-invoicings',
  templateUrl: './project-invoicings.component.html',
  styleUrls: ['./project-invoicings.component.css']
})
export class ProjectInvoicingsComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public grid?: GridOptions;

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(2196))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid().setRememberId(this.setting.view_id).setLoadDataFunction({ method: this.setting.p2_datatask_keyno, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    view_id: string;
    p2_datatask_keyno: number;
}
